const getShapeFromElement = (element: ShapeObject | ShapeObjectLine | Rip | Lintel | undefined) => {
  if (!element) return undefined

  if ('shape' in element) {
    return element.shape
  } else if ('start' in element) {
    return {
      start: element.start,
      end: element.end,
    }
  } else {
    return element
  }
}

export default getShapeFromElement
